import { GovernanceOverview } from "@/features/oversight/governance";

export default function GovernancePage() {
  return <GovernanceOverview />;
}
